import React, { useEffect, useRef, useState } from 'react';
import '../../../styles/mainContents.css'
import '../../../styles/navbar.css'
import { fetchConsignmentsCustomer, submitConsignmentsCustomerInventoryCount, setCustomerInventoryOnhand } from '../../../redux/actions/consignmentsPostActions';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { Padding } from '@mui/icons-material';
import moment from 'moment';
import { BaseButtonStyle } from '../../../styles/CommonStyling';

function InventoryCountEdit(props) {


  const { fetch_ConsignmentsCustomer, submitConsignmentsCustomerInventoryCount, setCustomerInventoryOnhand, consignmentsCustInventoryOnhandState, consignmentsCustInventoryCountEditState, dispatch_deleteRowLineOrdernoDetail, authreducerState } = props;

    const [ countCommentState, setCountCommentState ] = useState({
      COMMENT: null,                              
    });  

  const columnsOptions = (colName='', inputType='number',filterEnabled=true,displayType=true, downloadType=true) => {
    var options = {};
    let maxValue = 1000;
    
    colName === 'LAST_COUNTED_DATE' ?
      options = {
        filter: true, //filterEnabled,
        customFilterListOptions: { 
          render: v => `LAST_COUNTED_DATE: ${v}` 
        },
        filterOptions: {
          names: ['Last 7 Days', 'Last 30 Days', 'No Count', 'No Count in 7 Days', 'No Count in 30 Days'],
          logic(thisDate, filterVal){
            const show =
              (filterVal.indexOf('Last 7 Days') >= 0 && moment(new Date(thisDate)).toDate() > moment(new Date()).subtract(7, 'days').toDate()) ||
              (filterVal.indexOf('Last 30 Days') >= 0 && moment(new Date(thisDate)).toDate() > moment(new Date()).subtract(30, 'days').toDate()) ||
              (filterVal.indexOf('No Count') >= 0 && thisDate === null) ||
              (filterVal.indexOf('No Count in 7 Days') >= 0 && moment(new Date(thisDate)).toDate() <= moment(new Date()).subtract(7, 'days').toDate()) ||
              (filterVal.indexOf('No Count in 30 Days') >= 0 && moment(new Date(thisDate)).toDate() <= moment(new Date()).subtract(30, 'days').toDate());
            return !show;
          },
        },        
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,  
            padding: '8px 4px',       
          }
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {        
          return (
            <span style={{whiteSpace: "pre-wrap"}}>  
              <React.Fragment>              
                {consignmentsCustInventoryCountEditState[dataIndex][colName]}  
              </React.Fragment>                                                                                  
            </span>
          )                           
        }             
      } 
    :        
      options = {
        filter: filterEnabled,
        sort: true,
        download: downloadType,
        display: displayType,
        responsive: 'standard',
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: "pre-wrap",
            position: "sticky",
            top: '0px',
            zIndex: 101,            
          }
        }),  
        customBodyRenderLite: (dataIndex, rowIndex) => {
          //let newDetailState = [...consignmentsCustInventoryCountEditState]   


          if (colName === 'USER_INPUT_QTY'){        
            return (
              <span>              
                {authreducerState.user.role_name === undefined || 
                  (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ||
                  (consignmentsCustInventoryCountEditState[dataIndex]['LINE'] === 'C') ? 
                  ( 
                    <React.Fragment>
                      {consignmentsCustInventoryCountEditState[dataIndex]['USER_INPUT_QTY']}
                    </React.Fragment> 
                  ) 
                  : 
                  (
                    <React.Fragment>  
                      <input 
                        id={'iInventoryCountInputIndex' + dataIndex + '-' + rowIndex} 
                        //className={'userInputField'}
                        style={{'width':'6em'}}
                        type={inputType} 
                        name={'nInventoryCountInputIndex' + dataIndex + '-' + rowIndex}
                        key={dataIndex + '-' + rowIndex + '-' + consignmentsCustInventoryCountEditState[dataIndex]['PRDID']}
                        min="0"
                        max="2000"
                        
                        defaultValue={consignmentsCustInventoryOnhandState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']] === undefined ? '' : 
                          consignmentsCustInventoryOnhandState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']][consignmentsCustInventoryCountEditState[dataIndex]['PRDID']] === undefined ? '' : 
                          consignmentsCustInventoryOnhandState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']][consignmentsCustInventoryCountEditState[dataIndex]['PRDID']] }
                        onInput={(e) => {
                          var min = e.target.min
                          var val = e.target.value.replace(/[eE]|[^0-9]/g, '');
                          
                          if (val !== ''){
                            val = parseInt(val) || (min); // if input char is not a number the value will be (min - 1) so first condition will be true

                            if (val < min || e.target.value < min){                      
                              e.target.value = min
                              val = e.target.value
                            }                          
                          } 
                          else{
                            e.target.value = ''
                          }

                          console.log('consignmentsCustInventoryOnhandState',consignmentsCustInventoryOnhandState, 'length', Object.keys(consignmentsCustInventoryOnhandState).length)
                          let newDetailState = {}
                          if(Object.keys(consignmentsCustInventoryOnhandState).length > 0){
                            newDetailState = { ...consignmentsCustInventoryOnhandState }; 
                            //newDetailState = JSON.parse(JSON.stringify(consignmentsCustInventoryOnhandState)); 
                            
                            //console.log('InventoryCountEdit newDetailState',newDetailState)                            

                            if (val === '' || val.length === 0){
                              try {
                                delete  newDetailState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']][consignmentsCustInventoryCountEditState[dataIndex]['PRDID']]
                              } catch (error) {
                                console.log('unable to delete newDetailState[consignmentsCustInventoryCountEditState[dataIndex][CUSTID]][consignmentsCustInventoryCountEditState[dataIndex][PRDID]] error', error)
                              }
                            }
                            else{
                              console.log('InventoryCountEdit newDetailState[consignmentsCustInventoryCountEditState[dataIndex][CUSTID]]',newDetailState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']])                            
                              console.log('InventoryCountEdit e.target.value',e.target.value)
                              console.log('InventoryCountEdit consignmentsCustInventoryCountEditState[dataIndex][CUSTID]',consignmentsCustInventoryCountEditState[dataIndex]['CUSTID'])
                              console.log('InventoryCountEdit consignmentsCustInventoryCountEditState[dataIndex][PRDID]',consignmentsCustInventoryCountEditState[dataIndex]['PRDID'])

                              newDetailState[consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']][consignmentsCustInventoryCountEditState[dataIndex]['PRDID']] = e.target.value                           
                            }

                          }
                          else{
                            if (val !== ''){
                              newDetailState = {
                                [consignmentsCustInventoryCountEditState[dataIndex]['CUSTID']]: {
                                  [consignmentsCustInventoryCountEditState[dataIndex]['PRDID']]: e.target.value
                                }
                              };
                            }
                          }
                          console.log('dataIndex',dataIndex,'newDetailState', newDetailState)

                          setCustomerInventoryOnhand(newDetailState);


                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            const nextSibling =  e.target.closest('tr').nextElementSibling
                            if(nextSibling){
                              const nextInput = nextSibling.querySelector('input');
                              if (nextInput) {
                                nextInput.focus();
                              }
                            }                
                          }
                        }}         
                      />                                                                           
                      <div>
                        {consignmentsCustInventoryCountEditState[dataIndex]['LAST_COUNTED_DATE']}
                      </div>
                    </React.Fragment>
                  )
                }
              </span>
            )
          }
          else{
          
            return (
              <span>  
                <React.Fragment>              
                  {consignmentsCustInventoryCountEditState[dataIndex][colName]}  
                </React.Fragment>                                                                                  
              </span>
            )           
          }
          

        }             
      } 
    
    return options;
  }

  const columns = [  
    {
      name: "PRDID",
      label: "Prdid",
      options: {
        filter: false,
        display: "excluded", 
        download:false,
      },
      
    },     
    {
      name: "LINE",
      label: "line",
      options: columnsOptions('LINE', 'text', true, 'excluded', true)
    },
    {
      name: "CAT",
      label: "cat",
      options: columnsOptions('CAT', 'text', false, 'excluded', true),
    },    
    {
      name: "PARTNO",
      label: "partno",
      options: columnsOptions('PARTNO', 'text', false, 'excluded', true),
    },
    {
      name: "LINE_PARTNO",
      label: "LINE\nPARTNO",
      options: columnsOptions('LINE_PARTNO', 'text', false, true, false)
    },    
    {
      name: "DESCRIPTION",
      label: "DESC",
      options: columnsOptions('DESCRIPTION', 'text', false, true, true),
    },  
    {
      name: "CONSIGN",
      label: "consign",
      options: columnsOptions('CONSIGN', 'number', false, true, true),
    },    
    {
      name: "USER_INPUT_QTY",
      label: "INVENTORY\nCOUNT",
      options: columnsOptions('USER_INPUT_QTY', 'number', false, true, true),
    },  
    {
      name: "LAST_COUNTED_DATE",
      label: "last_counted_date",
      options: columnsOptions('LAST_COUNTED_DATE', 'text', true, 'excluded', false),
    },       
  ]



  const options = {
    filterType: "checkbox",
    fixedHeader: true,
    selectableRows: 'none',
    //responsive: "standard",
    print: false,
    responsive: 'simple',
    tableBodyHeight: "400px",
    searchAlwaysOpen: true,  
    onRowClick: (rowData, rowMeta) => {
      // console.log("InventoryCount options onRowClick rowData:" + JSON.stringify(rowData) + " rowMeta:" + JSON.stringify(rowMeta) + " orderDetailState[rowMeta[dataIndex]]:" + JSON.stringify(orderDetailState[rowMeta['dataIndex']]));
    },
    onChangePage (currentPage) {
      console.log({currentPage});
     
    },
    rowsPerPage: 200,
  };  


  const countSubmitBtn = () => {
    return (
      <BaseButtonStyle variant="contained" onClick={(e)=>
        {
          if( Object.keys(consignmentsCustInventoryOnhandState).length > 0 && Object.keys(consignmentsCustInventoryOnhandState[consignmentsCustInventoryCountEditState[0]['CUSTID']]).length > 0 ){
            if (window.confirm('Click Ok to submit Inventory Count or Cancel to not submit count.')) 
            {
              
              submitConsignmentsCustomerInventoryCount(authreducerState.user.userid, consignmentsCustInventoryCountEditState[0]['CUSTID'], countCommentState['COMMENT'], consignmentsCustInventoryOnhandState) 
              window.scrollTo({ top: 0, behavior: 'smooth' });              
            } 
            else 
            {
              console.log('Cancelled - Inventory Count was not saved.');
            } 
          }
          else{
            alert('No onhand qty entered');
            console.log('No onhand qty entered');
          }
        }
        }>Submit Count
      </BaseButtonStyle>

      // <button type='button' style={{'textAlign': 'left'}} id='submitInventoryCountDetail' onClick={(e)=> 
      //   {       
      //     // console.log('countCommentState',countCommentState['COMMENT'])
      //     // console.log('consignmentsCustInventoryOnhandState',consignmentsCustInventoryOnhandState)

      //     if( Object.keys(consignmentsCustInventoryOnhandState).length > 0 && Object.keys(consignmentsCustInventoryOnhandState[consignmentsCustInventoryCountEditState[0]['CUSTID']]).length > 0 ){
      //       if (window.confirm('Click Ok to submit Inventory Count or Cancel to not submit count.')) 
      //       {
              
      //         submitConsignmentsCustomerInventoryCount(authreducerState.user.userid, consignmentsCustInventoryCountEditState[0]['CUSTID'], countCommentState['COMMENT'], consignmentsCustInventoryOnhandState) 
      //         window.scrollTo({ top: 0, behavior: 'smooth' });              
      //       } 
      //       else 
      //       {
      //         console.log('Cancelled - Inventory Count was not saved.');
      //       } 
      //     }
      //     else{
      //       alert('No onhand qty entered');
      //       console.log('No onhand qty entered');
      //     }                                               
      //   }        
      // }>Submit Count</button>

    )    
  }

  const getMuiTheme = () =>
  createTheme({
    overrides: {
      MUIDataTableToolbar: {
        actions: {
          display: "flex",
          flex: "initial",
          // move all icons to the right
          "& > span, & > button": {
            order: 99
          },
          // target the custom toolbar icon
          "& > span:last-child, & > button:last-child": {
            order: 1
          },
          // target any icon
          "& > span:nth-child(4), & > button:nth-child(4)": {
            order: 2
          }
        }
      }
    }
  });

  return (

    <div>
        <div>   
          <div id='consignmentsInventoryCountTblId' className='detailTblClass'>

            { consignmentsCustInventoryCountEditState !== undefined && 
              consignmentsCustInventoryCountEditState !== null ?
              consignmentsCustInventoryCountEditState.length > 0 ?                
                <div>

                  <table id='inventoryCountTblHeader'>
                    <thead>
                      <tr>
                        <th colSpan='4'>Customer Consignments Inventory Data</th>
                      </tr>
                    </thead>
                    <tbody>                                
                          <React.Fragment>
                            <tr>
                              <td>Customer#:</td>
                              <td>
                                {consignmentsCustInventoryCountEditState[0]['CUSTNO']}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>
                                {consignmentsCustInventoryCountEditState[0]['CUSTNAME']} <br/>
                                {consignmentsCustInventoryCountEditState[0]['ADDR1']} <br/>
                                {consignmentsCustInventoryCountEditState[0]['ADDR2']} {consignmentsCustInventoryCountEditState[0]['ADDR2'] !== '' ? (<React.Fragment> <br/> </React.Fragment>) : ''}
                                {consignmentsCustInventoryCountEditState[0]['CITY']} {consignmentsCustInventoryCountEditState[0]['STATE']} {consignmentsCustInventoryCountEditState[0]['ZIP']}
                              </td>
                            </tr>
                          </React.Fragment>                                                         
                    </tbody>
                  </table>

                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable             
                      data={consignmentsCustInventoryCountEditState}
                      columns={columns}
                      options={options}
                    />
                  </ThemeProvider>

                  <div style={{'marginTop':'2em'}}>
                    Comments <input type='text' id="iAddComment" name="nAddComment" maxLength="100" onInput={ e => setCountCommentState({COMMENT: e.target.value})} ></input>
                  </div>

                  <div style={{'marginTop':'1em','marginBottom':'2em'}}>

                    <BaseButtonStyle variant="outlined" onClick={() => {
                      window.location.href='/' 
                    }}>BACK
                    </BaseButtonStyle>

                    <span> 
                      { 
                        (authreducerState.user.role_name === undefined) ? "" :                    
                          (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" :
                          countSubmitBtn()
                      } 
                    </span>

                  </div>
                </div>


                : ''
              : ''
          
            }

          </div>


        </div>
    </div>

  );
}



const mapStateToProps = (state) => {

 return {
  authreducerState: state.authreducer,

  consignmentsCustInventoryCountEditState: state.consignmentsPostReducer['items_fetchConsignmentsCustomerInventoryCountEdit'],
  consignmentsCustInventoryOnhandState: state.consignmentsPostReducer['items_consignmentsCustomerInventoryOnhand']
  
 }

};

const mapDispatchToProps = (dispatch) => {
  return {
    setCustomerInventoryOnhand: (rowState) => {
      dispatch(setCustomerInventoryOnhand(rowState));
    },  
    submitConsignmentsCustomerInventoryCount: (userid, custid, comments, rowState) => {
      dispatch(submitConsignmentsCustomerInventoryCount(userid, custid, comments, rowState));
    },  
    // fetch_ConsignmentsCustomer: (custnoState, showInventoryOnly, showInventoryCountEdit) => {
    //     dispatch(fetchConsignmentsCustomer(custnoState, showInventoryOnly, showInventoryCountEdit));
    // },    
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCountEdit);